import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

import { AuthContext } from './AuthContext';

export const ClientContext = createContext();

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/";

const ClientContextProvider = (props) => {

  const { token, logout } = useContext(AuthContext);
  const [ clients, setClients ] = useState([]);
  const [ spClients, setSPClients ] = useState([]);
  const [ spClientsLoading, setSPClientsLoading ] = useState(false);
  const [ selectedClient, setSelectedClient ] = useState(null);

  const loadSPClients = () => {

      setSPClientsLoading(true);

      //Cancel axios request when component unmounted
      let source = axios.CancelToken.source();

      axios.get(API_URL + 'sp/get-clients',  
      { 
        //Cancel axios request when component unmounted
        cancelToken: source.token,
        headers: {'Authorization': `Bearer ${token}`} 
      })
      .then(res => {        
          setSPClients(res.data);
          setSPClientsLoading(false);
      }).catch(error => {
        if (error.response) {
          logout();
        }
      });

      //Cancel axios request when component unmounted
      return () => {
        source.cancel();
      }
  }

  const loadClients = () => {
      //Cancel axios request when component unmounted
      let source = axios.CancelToken.source();

      axios.get(API_URL + 'get-clients',  
      { 
        //Cancel axios request when component unmounted
        cancelToken: source.token,
        headers: {'Authorization': `Bearer ${token}`} 
      })
      .then(res => {
          setClients(res.data.clients);
      }).catch(error => {
        if (error.response) {
          logout();
        }
      });

      //Cancel axios request when component unmounted
      return () => {
        source.cancel();
      }
  }
  
  return (   
      <ClientContext.Provider value={
          { 
            loadClients,
            clients,
            selectedClient, 
            setSelectedClient,
            spClients,
            loadSPClients,
            spClientsLoading
          }
      }>
          { props.children }
      </ClientContext.Provider>        
  );
}
 
export default ClientContextProvider;
